import { goto } from '$app/navigation';
import type { Race } from '$types/races';
import { writable } from 'svelte/store';

export const selectedRaceId = writable<string | null>(null);

export function getRaceLink(race: Pick<Race, 'meeting' | 'number'>) {
  return `/app/racing/${race.meeting.date}/${race.meeting.type[0]}/${race.meeting.track}/${race.number}`;
}

export async function gotoRace(
  race: Race,
  options?: { replaceState?: boolean }
) {
  selectedRaceId.set(race.id);
  return await goto(getRaceLink(race), options);
}

export async function gotoRaceById(
  raceId: string,
  options?: { replaceState?: boolean }
) {
  selectedRaceId.set(raceId);
  return await goto(`/app/racing/id/${raceId}`, options);
}
